(function () {

    "use strict";

    function entityTaskService($q, configurationService, workflowService, workflowActivityService, $mdToast, $mdDialog, $translate, $rootScope) {

        var self = this;

        self.workFlow = function (entityName) {
            return entityService(entityName);
        };

        self.loadConfiguracion = function () {

            return configurationService.loadConfiguracion();

        };

        function entityService(entityName) {

            var service = {};
            service.entityName = entityName;

            service.getTask = function (entity, workflowName, taskName) {

                var defered = $q.defer();
                var promise = defered.promise;
                configurationService.getActivityIdWorkflow(workflowName, taskName)
                    .then(function (idWorkflow) {
                        workflowService.resourceGetTask.query(
                            { idWorkflow: idWorkflow, action: 'activities', name: taskName, pageSize: 0, pageIndex: 10000 },
                            function (data) {
                                var entityTasks = data.items.filter(function (task) {
                                    return task.idFileItem === entity.id;
                                });

                                defered.resolve(entityTasks.length === 0 ? null : entityTasks[0]);
                            },
                            function (error) {
                                console.log(error);
                                defered.reject(error);
                            });

                    });

                return promise;
            };

            service.saveMetadataTask = saveMetadataTask;

            service.outTask = function (entity, task, outputName, entityName) {

                var defered = $q.defer();
                var promise = defered.promise;

                signedOutTask(outputName).then(
                    function () {
                        saveMetadataTask(entity, task, entityName).then(
                            function () {
                                workflowActivityService.resource.save({
                                    idWorkflowActivity: task.id, resultKey: outputName.Key,
                                    notCheckRequiredVariables: false
                                }, function (data) {
                                    defered.resolve(data);
                                }, function (error) {
                                    console.log(error);
                                    defered.reject(error);
                                });
                            },
                            function (error) {
                                console.log(error);
                                defered.reject(error);
                            }
                        );
                    },
                    function (error) {
                        console.log(error);
                        defered.reject(error);
                    }
                );


                return promise;

                function signedOutTask(outputName) {

                    var defered = $q.defer();
                    var promise = defered.promise;

                    if (!outputName.AssignSignDoc) {
                        defered.resolve();
                        return promise;
                    }
                    $rootScope.activatedSave = false;
                    $mdDialog.show(
                        {
                            controller: $rootScope.$new(true),
                            contentElement: '#signViewer',
                            parent: angular.element(document.body),
                            multiple: true,
                            clickOutsideToClose: false
                        }
                    ).then(
                        function () {
                            $rootScope.activatedSave = true;
                            defered.resolve(true);
                        }, function () {
                            $rootScope.activatedSave = true;
                            defered.reject({ cancel: true });
                        }
                    );

                    return promise;
                }
            };

            return service;
        }

        function mapValuesMetadata(entity, entityName) {
            var mappedMetadatas = [];
            var metadatas = $rootScope.metadata[entityName];
            var metadatasArray = Object.values(metadatas);

            metadatasArray.forEach(function (metadata) {
                var metadatas = getValuesMetadatas(entity, metadata);
                if (metadatas != null) { mappedMetadatas.push(metadatas); }
            });
            return mappedMetadatas;

        }

        function getValuesMetadatas(entity, metadata) {

            var itemObject = {
                "idMetadata": metadata.idMetadata,
                "idFileItem": (entity.id != null ? entity.id : 0),
                "value": entity[metadata.internalName]
            };
            return itemObject;
        }

        function saveMetadataTask(entity, task, entityName) {

            var defered = $q.defer();
            var promise = defered.promise;

            if (entity.isMappedVariables) {
                task.typedRelationsMetadatas.map(function (variable) {
                    variable.value = entity.variables[variable.name];
                    return variable;
                });
            }

            var metadatasSave = task.typedRelationsMetadatas;

            var metadatosValue = (entityName ? mapValuesMetadata(entity, entityName) : []);

            metadatasSave.forEach(function (metadata) {
                if (metadata.idMetadataFileContainer != null) {
                    metadatosValue.every(function (value) {
                        if (metadata.idMetadataFileContainer == value.idMetadata) {
                            metadata.value = value.value;
                            return false;
                        } else {
                            return true;
                        }
                    });
                }
            });

            workflowActivityService.resourceRelationsMetadatas.put(
                { idWorkflowActivity: task.id },
                { relationsMetadatas: metadatasSave },
                function () {
                    defered.resolve();
                },
                function (error) {
                    defered.reject(error);
                }
            );

            return promise;
        }

    }

    entityTaskService.$inject = ["$q", "solpheo.configurationService", "solpheo.workflowService", "sphforms.workflowActivityService", "$mdToast", "$mdDialog", "$translate", "$rootScope"];

    angular.module("solpheo").service("solpheo.entityTaskService", entityTaskService);

})();
